export default "__VITE_ASSET__ebdd8e4d__"